import { Component, OnInit, ChangeDetectionStrategy, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { GuestReservationSource } from 'src/models/guest-reservations';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { DateTime } from 'luxon';
import { Util } from 'src/shared/util/util';
import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';
import { SharedModule } from 'src/shared/shared.module';

@Component({
  templateUrl: 'channel-sync-details.html',
  styleUrls: ['./channel-sync-details.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IonicModule, TidyUiComponentsModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChannelSyncDetailsPage implements OnInit {
  private readonly storage = inject(TidyStorage);
  private readonly util = inject(Util);

  channels: GuestReservationSource[] = [];
  isRightSideContent = true;
  loaded = false;
  icalUrl = '';

  async ngOnInit() {
    this.isRightSideContent = (await this.storage.retrieve('dialog-right-side-open')) || false;

    if (this.isRightSideContent) {
      const dialogParams = await this.storage.retrieve('dialog-params');
      this.channels = dialogParams?.channels || [];
    } else {
      this.channels = (await this.storage.retrieve('channel-sync-data')) || [];
    }

    await this.loadIcalUrl();
    this.loaded = true;
  }

  async loadIcalUrl() {
    const clientId = await this.storage.retrieve('client_id');
    const icalToken = await this.storage.retrieve('ical_token');

    if (clientId && icalToken) {
      this.icalUrl = `${window.location.origin}/ical/${clientId}/${icalToken}.ics`;
    } else {
      this.icalUrl = `${window.location.origin}/ical/your-calendar-feed.ics`;
    }
  }

  async copyIcalUrl() {
    try {
      await navigator.clipboard.writeText(this.icalUrl);
      this.util.showSuccess('iCal URL copied to clipboard');
    } catch (error) {
      this.util.showError('Failed to copy URL');
    }
  }

  formatSyncTime(lastSyncAt: string): string {
    if (!lastSyncAt) {return 'Never synced';}

    const syncDate = DateTime.fromISO(lastSyncAt);
    const now = DateTime.now();
    const diff = now.diff(syncDate, ['days', 'hours', 'minutes']);

    if (diff.days >= 1) {
      return syncDate.toFormat('MMM dd, yyyy');
    } else if (diff.hours >= 1) {
      return `${Math.floor(diff.hours)} hours ago`;
    } else {
      return `${Math.floor(diff.minutes)} minutes ago`;
    }
  }

  getSyncStatusColor(state: string): string {
    switch (state) {
      case 'active':
        return '#4CAF50';
      case 'syncing':
        return '#2196F3';
      case 'error':
        return '#F44336';
      case 'paused':
        return '#9E9E9E';
      default:
        return '#9E9E9E';
    }
  }
}
